<template>
    <Spin fix v-show="isSpinShow">
        <Icon type="ios-loading" size="25" class="demo-spin-icon-load"></Icon>
        <div>Loading...</div>
    </Spin>
</template>
<script>
    export default {
        props: ['isSpinShow'],
        data () {
            return {
            }
        },
        created(){
        },
        watch: {
        },
        methods: {
        },
    }
</script>
<style lang="less" >
/* 旋转效果 */
.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
   from { transform: rotate(0deg);}
   50% { transform: rotate(180deg);}
   to { transform: rotate(360deg);}
}
/* 假如内容过长，一屏放不下，滚动条下拉覆盖不全 */
.ivu-spin-fix {
    position: fixed;
}
</style>
